<div class="m-2" [ngClass]="small ? 'w-24 h-32' : 'w-36 h-46'">
  <div class="size-0 relative z-20 -top-1 -left-1">
    <div
      class="flex justify-center items-center rounded-full bg-(--RJ-primario) text-(--M-white)!"
      [ngClass]="small ? 'size-7 text-general-small' : 'size-10 text-general-subtitle'"
    >
      {{ totalProducts }}
    </div>
  </div>

  @if (supply[0]) {
    <img
      class="rounded-3xl bg-contain bg-center bg-no-repeat shrink-0! relative top-0 left-0"
      [ngClass]="small ? 'w-20 h-20' : 'w-30 h-30'"
      [src]="`../../../../assets/img/PNGs/${supply[0]?.Supply?.Code}.png`"
      [alt]="supply[0]?.Supply?.Description"
    />
  }
  @if (supply[1]) {
    <img
      class="rounded-3xl bg-contain bg-center bg-no-repeat shrink-0! relative left-2 z-5"
      [ngClass]="small ? 'w-20 h-20 -top-16' : 'w-30 h-30 -top-26'"
      [src]="`../../../../assets/img/PNGs/${supply[1]?.Supply?.Code}.png`"
      [alt]="supply[1]?.Supply?.Description"
    />
  }
  @if (supply[2]) {
    <img
      class="rounded-3xl bg-contain bg-center bg-no-repeat shrink-0! relative left-4 z-10"
      [ngClass]="small ? 'w-20 h-20 -top-32' : 'w-30 h-30 -top-52'"
      [src]="`../../../../assets/img/PNGs/${supply[2]?.Supply?.Code}.png`"
      [alt]="supply[2]?.Supply?.Description"
    />
  }
  @if (supply[3]) {
    <img
      class="rounded-3xl bg-contain bg-center bg-no-repeat shrink-0! relative left-6 z-15"
      [ngClass]="small ? 'w-20 h-20 -top-48' : 'w-30 h-30 -top-76'"
      [src]="`../../../../assets/img/PNGs/${supply[3]?.Supply?.Code}.png`"
      [alt]="supply[3]?.Supply?.Description"
    />
  }
</div>
